import React from 'react';
import { Avatar, AvatarProps, Box } from '@mui/material';


import { makeStyles } from 'tss-react/mui';


const useStyles = makeStyles<HighlightableAvatarProps>()(theme => ({
  root: {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.grey[600],

    width: '32px',
    height: '32px',
    fontSize: '14px',
    fontWeight: 500,
  },
  rootHighlighted: {
    color: theme.palette.secondary.main,
  },
  outlineRoot: {
    border: '1px solid transparent',
    padding: '1px',
    borderRadius: '50%',
    transitionDuration: '140ms',
  },
  outlineHighlighted: {
    border: `1px solid ${theme.palette.secondary.main}`,
  }
}));

export type HighlightableAvatarProps = AvatarProps & { highlighted?: boolean };
export const HighlightableAvatar: React.FC<HighlightableAvatarProps> = ({ highlighted, ...props }) => {
  const {
    cx,
    classes: {
      outlineRoot,
      outlineHighlighted,
      rootHighlighted,
      ...classes
    }
  } = useStyles(props, { props });

  return (
    <Box
      className={cx(outlineRoot, {
        [outlineHighlighted]: highlighted,
      })}
    >
      <Avatar
        {...props}
        classes={classes}
        className={cx({ [rootHighlighted]: highlighted })}
      />
    </Box>
  );
};
